import React from 'react'
import { connect } from 'react-redux'
import { addListItem, changeListItem, deleteListItem, getMixedListValues, nullDate, TDate, getListFromValues, getListItems } from '../../public/utility'
import { hasChangedValues, getFormValue, changeItemsValue } from '../../public/utility/formValues'

class ExpenseDetailDiv extends React.Component {
    state = {
        changedValues基本信息: {},
    }

    componentDidMount = () => {
        const { id, advanceExpenseID } = this.props
        Tyan.doPostEvent({
            event: 'GetBTExpenseDtail',
            data: { id, advanceExpenseID },
            onEnd: ({ errorMessage, initValues基本信息},optionsParas) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    this.setState({ id, initValues基本信息, changedValues基本信息: {},optionsParas})
                }
            }
        })
    }

    handlerSave = () => {
        
        const { onClose, onSave, advanceExpenseID } = this.props
        const { id, changedValues基本信息 } = this.state
        const 日期 = getFormValue(this, '基本信息', '日期')
        Tyan.doPostEvent({
            event: 'SaveBTExpenseDtail',
            data: { id, advanceExpenseID, changedValues基本信息 },
            
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                    onSave && onSave()
                }
            }
        })
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    handlerDelete = () => {
        const { id } = this.state
        const { onSave, onClose } = this.props
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent({
                event: 'DeleteBTExpenseDtail',
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    }
                    else {
                        Ext.toast('删除成功')
                        onSave && onSave()
                        onClose && onClose()
                    }
                }
            }))
    }

    // handleCurrencyNameChange = (v) => {
    //     const 申请时间 = getFormValue(this, '基本信息', '申请时间')
    //     Tyan.doPostEvent({
    //         event: 'GetExchangeRateByCurrency',
    //         data: { 币别: v, 申请时间 },
    //         onEnd: ({ errorMessage, ExchangeRate }) => {
    //             if (errorMessage) {
    //                 Tyan.pubForm.showError(errorMessage)
    //             }
    //             else {
    //                 changeItemsValue(this, '基本信息', ['汇率'], [ExchangeRate])
    //                 this.AutoCalculation()
    //             }
    //         }
    //     })
    // }

    // AutoCalculation = () => {
    //     const 金额 = getFormValue(this, '基本信息', '金额')
    //     const 汇率 = getFormValue(this, '基本信息', '汇率')
    //     var 人民币金额 = 金额
    //     if (汇率) {
    //         人民币金额 = 金额 / 汇率
    //     }
    //     changeItemsValue(this, '基本信息', ['人民币金额'], [人民币金额])
    // }

    bChanged = () => {
        return hasChangedValues(this)
    }

    canSave = () => {
        return getFormValue(this, '基本信息', '开始日期') &&
            getFormValue(this, '基本信息', '结束日期') &&
            getFormValue(this, '基本信息', '出发地') &&
           getFormValue(this,'基本信息','目的地')
    }

    fieldset基本信息 = () => {
        return [
            { _date: '开始日期' ,minWidth: '50%',required:true},
            { _date: '结束日期' ,minWidth: '50%',required:true},
            { _text: '出发地' ,minWidth: '50%',required:true},
            { _text: '目的地' ,minWidth: '50%',required:true},
            { _float: '飞机票', minWidth: '95%', },
            { _float: '火车票', minWidth: '50%'},
            { _float: '船票', minWidth: '50%'},
            { _float: '公交', minWidth: '50%'},
            { _float: '出租', minWidth: '50%'},
            { _float: '公里补助', minWidth: '50%'},
            { _float: '停车费', minWidth: '50%'},
            { _checkbox: '膳食费',  minWidth: '70%',itemMinWidth: 80, items: ['早：10元','中：25元','晚：25元',],required:false ,},
            // {_float:'膳食费',minWidth:'60%'},
            {_float:'其他膳食费',minWidth:'20%'},
            { _float: '住宿费', minWidth: '95%' },
            { _float: '其他', minWidth: '95%' },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body, readOnly } = this.props
        const { errorMessage, id, initValues基本信息 } = this.state
        if (errorMessage) return Tyan.pubForm.showError(errorMessage)
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />
        return <Body data={this} maxWidth="700"
            controls={
                readOnly ? [
                    { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                ] :
                    [
                        { _button: '保存', icon: 'save', handler: this.handlerSave, disabled: !(this.canSave() && this.bChanged()), },
                        { _button: '删除', icon: 'trash-o', ui: 'action decline alt', cdt: () => id > 0, handler: this.handlerDelete, disabled: this.bChanged() },
                        { _button: this.bChanged() && '取消' || '关闭', icon: 'close', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly },
                ]
            }
        />
    }
}

export default connect()(ExpenseDetailDiv)